<template>
  <div class="row flex-nowrap pl-3 pr-3">
    <div class="col-4 flex-1 pb-2" style="margin-right: 0.75rem; border-right: 1px solid #DCDFE9;">
      <h5 class="font-weight pt-2">Thông tin đơn hàng, khách hàng</h5>
      <div class="font-weight pt-2">Mã đơn hàng</div>
      <div class="px-2 py-1" style="background-color: #fff; border: 1px solid #DCDFE9; border-radius: 4px">
                  <span class="text-primary ml-1">
                    {{ order.code }}
                  </span>
        <el-tooltip class="item" effect="dark" content="Sao chép" placement="top">
          <i style="float:right" class="pointer el-icon-copy-document mt-1" @click="copy(order.code)">
          </i></el-tooltip>
      </div>
      <div class="pt-3">
        <span class="font-weight">Ngày tạo: </span> <span class="float-end"> {{ convertTime(order.createdAt) }} </span>
      </div>
      <div class="pt-3">
        <span class="font-weight">Tên khách hàng: </span> <span class="float-end"> {{ order.customer.name }} </span>
      </div>
      <div class="pt-3">
        <span class="font-weight">Số điện thoại: </span> <span class="float-end"> {{ order.customer.phone }} </span>
      </div>
      <div class="pt-3">
        <span class="font-weight">Địa chỉ: </span> <span class="float-end"> {{ order.customer.address }} </span>
      </div>
      <div class="pt-3">
        <span class="font-weight">Ghi chú: </span> <span class="float-end"> {{ order.noteCustomer || "Không có ghi chú"
        }} </span>
      </div>

      <hr>

      <div class="fw-bolder">Lịch sử trạng thái đơn hàng</div>
      <div v-for="(historyState, index) in order.historyState" :key="index">
        <div class="pt-2">
          <span> {{ convertTime(historyState.updatedAt) }} </span>
          <div class="float-end fw-semibold font-size-12 px-1"
               :style="{color: app.colorOrder[historyState.state], 'background-color': setTransparencyHex(app.colorOrder[historyState.state],0.2),'border-color': setTransparencyHex(app.colorOrder[historyState.state],0.2),'margin':'1px 4px 3px 1px','border-radius':'4px'}">
            {{ historyState.state }}
          </div>
        </div>
        <div class="pt-2 font-italic text-break"> {{ historyState.note }}</div>
      </div>
    </div>
    <div class="col-4 flex-1 pb-2" style="margin-right: 0.75rem;border-right: 1px solid #DCDFE9;">
      <h5 class="font-weight pt-2">Thông tin sản phẩm, doanh thu</h5>
      <div class="font-weight pt-2">Danh sách sản phẩm</div>
      <div v-for="(it,i) in order.swItems" :key="i" class="row my-1">
        <div class=" mt-1">
          <div class="clearfix">
            <el-image class="me-2 rounded"
                      :src="(it.image !== '' && it.image != null) ? it.image : '/assets/images/empty_product.svg'"
                      style="float:left;object-fit: cover;width: 80px;height: 80px "></el-image>
            <el-tooltip class="item" effect="dark" :content="it.name" placement="top-end">\
              <div class="text-normal  text-break text-2-line">{{ it.name }}</div>
            </el-tooltip>
          </div>
        </div>
        <div>
          <div class="m-1">
            <div class="font-size-12"><span class="fw-bolder">SL:</span> {{ it.amount }} x {{
                new Intl.NumberFormat("vi-VN", {
                  style: "currency",
                  currency: "VND"
                }).format(it.price)
              }}
            </div>
          </div>
        </div>
      </div>
      <hr>

      <div class="font-weight pt-2">Chính sách giá: <span
        class="float-end">{{ order.price_policy === "retail_price" ? "Bán lẻ" : "Bán buôn" }} </span></div>
      <div class="font-weight pt-2">Chiết khấu: <span class="float-end">{{ new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND"
      }).format(order.discount)
        }} </span></div>

      <div class="font-weight pt-2">Khách trả trước: <span class="float-end">{{ new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND"
      }).format(order.paid)
        }} </span></div>

      <div class="font-weight pt-2">Phụ thu: <span class="float-end"> {{
          new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND"
          }).format(order.otherFee)
        }}</span></div>

      <div class="font-weight pt-2">
        <span>Doanh thu đơn hàng: </span> <span class="text-danger float-end">{{
          new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND"
          }).format(order.totalPrice)
        }}</span>
      </div>

      <div class="font-weight pt-2">
        <span>Tiền COD:  </span> <span class="text-danger float-end">{{
          new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND"
          }).format(order.pickMoney)
        }}</span>
      </div>
    </div>

    <div class="col-4 flex-1 pb-2">
      <h5 class="font-weight pt-2">Thông tin vận chuyển</h5>
      <div class="font-weight pt-2">
        Đơn vị vận chuyển: <span class="float-end">{{ order.delivery.logistic }}</span>
      </div>
      <div v-if="order.delivery.logistic === 'AHAMOVE'" class="pt-2"><span
        class="font-weight"> Loại dịch vụ: </span><span class="float-end">{{ getNameService(order.service_id) }}</span>
      </div>
      <div class=" pt-2"><span class="font-weight">Bên trả phí vận chuyển: </span><span
        class="float-end">{{ order.payment_type_id === 1 ? "Người bán" : "Người mua" }}</span></div>
      <div class="pt-2">
        <b>Phí vận chuyển: </b> <span class="float-end">{{
          new Intl.NumberFormat("vi-VN", {
            style: "currency",
            currency: "VND"
          }).format(order.shippingFee)
        }}</span>
      </div>

      <div class="pt-2">
        <b>Ghi chú: </b> <span class="float-end">{{
          order.noteShipper || "Không có ghi chú"
        }}</span>
      </div>

      <hr>

      <div class="fw-bolder">Lịch sử vận chuyển</div>

      <div></div>

    </div>

  </div>

</template>

<script>
export default {
  name: "OrderDetail",
  props: ["order"],
  data() {
    return {
      clipboard: {
        copy: "Sao chép",
        copied: "Đã sao chép"
      }
    };
  }, methods: {
    getNameService(id) {
      let ahamoveService = [{ value: "HAN-BIKE", text: "Siêu Tốc" }, {
        value: "HAN-SAMEDAY",
        text: "4H"
      }, { value: "HAN-AHAPRO", text: "Siêu Cấp" }, { value: "HAN-POOL", text: "Siêu Rẻ" }];
      return ahamoveService.find(s => s.value === id).text;
    },
    copy(code) {
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Đã sao chép");
    }
  },


  mounted() {

  }
};
</script>


<style scoped>

.font-weight {
  font-weight: 700;
}

.card {
  border-radius: 0rem;
}

.copy {
  padding-top: 0.2rem;
}

.btn-close {
  position: absolute;
  top: 2vh;
  right: 3vh;
}

.scroll-order {
  overflow: scroll;
}

.scrollbarHide::-webkit-scrollbar {
  display: none;
}

.card-info {
  height: 80vh;
  display: flex;
  flex-flow: row wrap;
  margin-right: -20px;
  margin-left: -20px;
}

.pointer {
  cursor: pointer;
}

</style>
yle>